import { useSelector } from "react-redux";
import getTranslationData from "../../TranslationUtility/TranslationUtility.js";
import { useState } from "react";
import { useEffect } from "react";

const PurchaseLimitPill = () => {
  const isLoggedIn = sessionStorage.getItem("login") !== "true";
  const translation = getTranslationData();

  const productReducer = useSelector((state) => state.productReducer);

  const customerProductData = useSelector(
    (state) => state.customerProductReducer?.getCustomerProduct
  );
  const customerPropurchaseLimitType = useSelector(
    (state) =>
      state.clientConfigurationReducer?.clientConfigurationData[0]
        ?.purchaseLimitType
  );
  const [purchasedLimit, setPurchasedLimit] = useState({
    productLimit: 0,
    totalPurchasedValue: 0,
  });

  useEffect(() => {
    let totalLimit = productReducer?.data?.[0]?.productBudget?.limits?.find(
      (item) => item?.limitType === customerPropurchaseLimitType
    );

    if (Array.isArray(customerProductData)) {
      const limitByType = customerProductData?.find(
        (item) => item?.limitType === customerPropurchaseLimitType
      );

      setPurchasedLimit({
        ...limitByType,
        productLimit: totalLimit?.limitValue,
      });
    } else {
      setPurchasedLimit({
        productLimit: totalLimit?.limitValue,
        totalPurchasedValue: 0,
      });
    }
  }, [customerProductData, customerPropurchaseLimitType]);

  if (!purchasedLimit.productLimit || isLoggedIn) {
    return <></>;
  }

  return (
    <>
      <span className="redm-type text-end">
        {translation?.rem_limit_heading}
      </span>
      <div className="d-flex justify-content-end">
        <span className="redeem-amont-pill">
          ₹{purchasedLimit?.productLimit - (purchasedLimit?.totalPurchasedValue || 0)}
        </span>
      </div>
    </>
  );
};

export default PurchaseLimitPill;
